<template>
  <div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h4>
                    زيارات اولياء الامور <button v-b-modal.add class="btn btn-sm btn-primary" @click="dayname()">
                        <i class="fa fa-plus"></i>
                        تسجيل زيارة جديدة
                    </button>
                </h4>
                <div class="gs">
                    <button class="btn btn-sm btn-danger" v-b-modal.filter style="border-radius: 0px 5px 5px 0px">
                        <i class="fa fa-filter"></i>
                        فلترة النتائج
                    </button>
                    <button class="btn btn-sm btn-warning" style="border-radius: 5px 0px 0px 5px" @click="print(items)">
                        <i class="fa fa-print"></i>
                        طباعة الصفحة
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>
                                    الطالب
                                </th>
                                <th>
                                    الصف
                                </th>
                                <th>
                                    التاريخ
                                </th>
                                <th>
                                    الموضوع
                                </th>
                                <th>
                                    خيارات
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item._id">
                                <td>
                                    {{ getStudent(item.number).name }}
                                </td>
                                <td>
                                    {{ getStudent(item.number).classname }}
                                </td>
                                <td>
                                    {{ item.date }}
                                </td>
                                <td>
                                    {{ item.content }}
                                </td>
                                <td class="hidemonprint">
                                    <b-dropdown dropleft style="width: 100%"
                                        id="dropdown-1"
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        text="خيارات"
                                        variant="secondary"
                                        size="sm"
                                    >
                                        <b-dropdown-item @click="print([item])">
                                            <i class="fa fa-print"></i>
                                            طباعة
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="deleteItem(item._id)">
                                            <i class="fa fa-trash"></i>
                                            حذف
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <b-modal id="add" hide-footer size="sm">
        اختر الطالب:
        <v-select :options="students" dir="rtl" v-model="selectedStudent" placeholer="اختر الطالب..." label="name">
        </v-select>
        <br>
        <div class="form-group">
          <label for="">التاريخ</label>
          <input type="date"
            class="form-control" v-model="visit.date" @change="dayname()">
        </div>
        <div class="form-group">
          <label for="">اليوم</label>
          <input type="text"
            class="form-control" v-model="visit.day">
        </div>
        <div class="form-group">
          <label for="">الساعة</label>
          <input type="time"
            class="form-control" v-model="visit.time">
        </div>
        <div class="form-group">
          <label for="">اسم ولي الامر</label>
          <input type="text"
            class="form-control" v-model="visit.parent_name">
        </div>
        <div class="form-group">
          <label for="">صلة القرابة</label>
          <input type="text"
            class="form-control" v-model="visit.relation">
        </div>
        <div class="form-group">
          <label for="">طريقة التواصل</label>
          <input type="text"
            class="form-control" v-model="visit.contact">
        </div>
        <div class="form-group">
          <label for="">الغرض من الحضور</label>
          <input type="text"
            class="form-control" v-model="visit.reason">
        </div>
        <div class="form-group">
          <label for="">الموضوع</label>
          <textarea class="form-control" v-model="visit.content" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label for="">الاجراء المتخذ</label>
          <input type="text"
            class="form-control" v-model="visit.action">
        </div>
        <div class="col-12 text-center g">
            <button class="btn btn-primary" @click="addBreak()">
                تسجيل الزيارة
                <i class="fa fa-arrow-left"></i>
            </button>
        </div>
    </b-modal>
    <b-modal id="filter" hide-footer size="sm">
        اختر الطالب: (اتركه فارغاً لتحديد الكل)
        <v-select :options="students" dir="rtl" v-model="student_number" placeholer="اختر الطالب..." label="name">
        </v-select>
        <br>
        <div class="form-group">
          <label for="">التاريخ من</label>
          <input type="date"
            class="form-control" v-model="from">
        </div>
        <div class="form-group">
          <label for="">التاريخ الى</label>
          <input type="date"
            class="form-control" v-model="to">
        </div>
        <div class="col-12 text-center g">
            <button class="btn btn-primary" @click="closeFilter();getItems()">
                <i class="fa fa-search"></i>
                بحث
            </button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput, BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
    components: {
        // Layouts
        BDropdown, BDropdownItem,
        vSelect,
        BModal,BFormInput},
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            items: [],
            user: JSON.parse(localStorage.getItem('user')),
            visit: {day: "", date: new Date().toISOString().split("T")[0]},
            from: "",
            to: "",
            students: [],
            selectedStudent:  { name: "", number: "" },
            student_number:  { name: "", number: "" },
            content: "",
            action: "",
            numbers: {},
            day: "",
            date: new Date().toISOString().split("T")[0]
        }
    },
    created(){
        if(!checkPer("students|breaks-visits")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.getStudents();
    },
    methods: {
        closeFilter(){
            $("#filter___BV_modal_header_ > button").click();
        },
        getItems(){
            var g = this;
            $.post(api + '/user/students/breaks/visits/list', {
                jwt: this.user.jwt,
                number: this.student_number.number,
                from: this.from,
                to: this.to
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.items = r.response
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        getStudents(){
            var g = this;
            $.post(api + '/user/students/list', {
                jwt: this.user.jwt,
                q: this.q,
                page: 1,
                perpage: 10000
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.students = r.response
                    g.students.forEach(function(a){
                        g.numbers[a.number] = a;
                    })
                    g.getItems()
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        getStudent(number){
            return this.numbers[number] ?? {};
        },
        addBreak(){
            var g = this;
            $.post(api + '/user/students/breaks/visits/add', {
                jwt: g.user.jwt,
                number: g.selectedStudent.number,
                visit: g.visit
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    $("#add___BV_modal_header_ > button").click();
                    g.getItems()
                }
            }).fail(function(){
                alert("حدث خطأ", 200)
            })
        },
        deleteItem(id){
            var g = this;
            if(confirm("متأكد من حذف الزيارة؟")){
                var g = this;
                $.post(api + '/user/students/breaks/visits/delete', {
                    jwt: g.user.jwt,
                    id: id
                }).then(function(r){
                    g.loading = false
                    if(r.status != 100){
                        alert(r.response, 200)
                    }else{
                        g.getItems()
                    }
                }).fail(function(){
                    alert("حدث خطأ", 200)
                })
            }
        },
        dayname(){
            var days = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
            var d = new Date(this.visit.date);
            this.visit.day = days[d.getDay()];
        },
        print(arr){
            var tbody = '', index = 0, g = this;
            arr.forEach(function(a){
                index++
                tbody = tbody + `
                <table class='table table-bordered table-striped table-sm'>
                    <tbody>
                        <tr>
                            <td style='background: #E4DEBE'>
                                اليوم
                            </td>
                            <td>
                                ${a.day}
                            </td>
                            <td style='background: #E4DEBE'>
                                التاريخ
                            </td>
                            <td>
                                ${a.date}
                            </td>
                            <td style='background: #E4DEBE'>
                                التوقيت
                            </td>
                            <td>
                                ${a.time}
                            </td>
                        </tr>
                        <tr>
                            <td style='background: #E4DEBE'>
                                اسم الطالب
                            </td>
                            <td>
                                ${g.getStudent(a.number).name}
                            </td>
                            <td style='background: #E4DEBE'>
                                الصف
                            </td>
                            <td>
                                ${g.getStudent(a.number).classname}
                            </td>
                            <td style='background: #E4DEBE'>
                                اسم ولي الامر
                            </td>
                            <td>
                                ${a.parent_name}
                            </td>
                            <td style='background: #E4DEBE'>
                                صلة القرابة
                            </td>
                            <td>
                                ${a.relation}
                            </td>
                        </tr>
                        <tr>
                            <td style='background: #E4DEBE'>
                                طريقة التواصل
                            </td>
                            <td>
                                ${a.contact}
                            </td>
                            <td style='background: #E4DEBE'>
                            الغرض من الحضور
                            </td>
                            <td>
                                ${a.reason}
                            </td>
                            <td style='background: #E4DEBE'>
                            الموضوع
                            </td>
                            <td>
                                ${a.content}
                            </td>
                            <td style='background: #E4DEBE'>
                            الإجراءات المتخذة
                            </td>
                            <td>
                                ${a.action}
                            </td>
                        </tr>
                    </tbody>
                </table><br>
                `
            })
            var win = window.open("", "")
            win.document.write(`
            <html dir='rtl'>
                <head>
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/4.6.2/css/bootstrap.min.css"/>
                </head>
                <body>
                    <div class='container-fluid'>
                        <br>
                        <div class='row'>
                            <div class='col-4 text-center'>
                            <h5>
                                المملكة العربية السعودية
                                <br><br>${window.ministry_name}
                            </h5>
                            </div>
                            <div class='col-4 text-center'>
                                <img style='width: 200px' src='${window.ministry_logo}'>

                            </div>
                            <div class='col-4 text-center'>
                            <h5>
                                ${g.user.name}
                            </h5>
                            </div>
                            <div class='col-12'>
                                <center><h2 class='text-danger'>بيان حضور أولياء الأمور للمدرسة</h2></center>
                                <br>
                                ${tbody}
                            </div>
                        </div>
                    </div>
                </body>
            </html>
            `)
            win.document.close()
            setTimeout(() => {
                win.print()
            }, 1000);
        }
    }
}
</script>

<style>
@import url(https://cdnjs.cloudflare.com/ajax/libs/vue-select/3.10.0/vue-select.css);
#vs3__listbox{
    max-height: 150px !important;
    overflow: hidden !important;
}
</style>